<div class="site-dashboard" [class.site-dashboard--mobile]="device.isMobile()">

  <!-- ── Panel : General information ──────────────────────────────────────── -->
  <div class="site-dashboard__panel">
    <app-panel title="General information">

      <div class="info-list" [class.info-list--grid]="device.isMobile()">
        @if (utilService.currentSite(); as site) {
          <div class="info-item">
            <span class="info-item__label">Site name</span>
            <span class="info-item__value">{{ site.nom }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">Area name</span>
            <span class="info-item__value">{{ site.region?.nom }}</span>
          </div>
        } @else {
          <span class="info-item__empty">No site selected</span>
        }
      </div>

    </app-panel>
  </div>

  <!-- ── Dashboard Metabase ─────────────────────────────────────────────────── -->
  <div class="site-dashboard__main">
    @if (loadMetabase()) {
      <app-metabase-dashboard
        componentSelector="app-mon-site">
      </app-metabase-dashboard>
    } @else {
      <div class="site-dashboard__loading"></div>
    }
  </div>

</div>
